<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file AccountSideBar.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  AccountSideBar.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: AccountSideBar 
 Created by keni.
 with: IntelliJ IDEA
 Date: 27/04/2018
 Time: 13:20
------------------------------------------------------------------------------->
<template>
    <div :class="[
        view_purchases?`${col_view_purchases}`:`${col_lg} ${order_end}`
    ]">
        <!--plates-->
        <transition name="fade">
            <card-basic
                    v-show="!view_purchases"
                    data-module-type="plates"
                    class="mb-2"
                    :class="{
                    'mb-5 mb-md-1':needs_plate_asset
                                    }"
                    v-if="display.plates"
                    title_class="d-block"
                    title_elm="div"
                    :display="{
        image_content:'',
        title_content:'Plates',
        summary_content:'',
        footer_content:''
        }"
            >

                <template slot="title" is="div">
                    <div v-if="needs_plate_asset && creating_plate === false"
                         v-on:click="createAsset('plate')"
                         class="list-group-item text-center pulse-animation pulse-animation-danger text-contrast-danger p-3 cursor-pointer"
                    >
                        <h2 class="m-3">
                            <span>Add reg plate</span><br>
                        </h2>
                        <span class="font-weight-normal text-lowercase fs-3">A vehicle registration number is required to use your ticket</span>
                    </div>
                    <div v-if="!needs_plate_asset || creating_plate === true"
                         class="h5 d-flex justify-content-between align-items-center"
                    >
                        <h5>Plates</h5>
                        <template v-if="!newAsset.plate">
                            <div v-on:click="createAsset('plate')">
                                <round-button btn_type="btn-primary"
                                              cls="btn-floating-responsive ml-0 my-0 mr-1"
                                              :small="false"
                                >
                                    <template slot="content">
                                        +
                                    </template>
                                </round-button>
                            </div>

                        </template>
                        <template v-else
                        >
                            <div v-on:click="cancelAsset('plate')"
                            >
                                <round-button btn_type="btn-info"
                                              cls="btn-floating-responsive ml-0 my-0 mr-1"
                                              :small="false"
                                >
                                    <template slot="content">
                                        -
                                    </template>
                                </round-button>
                            </div>
                        </template>
                    </div>
                </template>

                <!--plates crud-->
                <template slot="main">
                    <div v-if="isEmpty(platesList) && !needs_plate_asset">
                        <BaseLoadingAnimation class="mb-2"></BaseLoadingAnimation>
                    </div>
                    <ul v-else
                        class="list-group"
                    >
                        <transition name="fade">
                            <div v-if="plates.max_notify"
                                 v-on:click="plates.max_notify = false"
                                 class="list-group-item active bg-warning text-contrast-warning text-center"
                            >
                                <h4>Maximum plates stored</h4>
                                <div>A maximum of {{plates.max_limit}} plates can be stored. Remove one to add a new
                                    plate
                                </div>
                                <div class="btn btn-primary">OK</div>
                            </div>
                        </transition>
                        <!--the plate form -->
                        <transition name="fade">
                            <li v-if="newAsset.plate"
                                :id="`${plateModelId}--new-plate`"
                                class="list-group-item active container-fluid my-5"
                            >
                                <h5>
                                    Enter Reg Plate
                                </h5>
                                <div class="row d-md-flex justify-content-md-between align-items-center my-5">
                                    <div class="col-12 col-sm-8 mb-5 mb-sm-0 text-left">
                                        <input :id="plateModelId"
                                               type="text"
                                               class="plate w-100 w-md-unset"
                                               v-model="plateModel"
                                               title="new_plate_asset"
                                        >
                                    </div>
                                    <div class="col-12 col-sm-4 mt-5 mt-sm-0 text-right">
                                        <div v-on:click="storeAsset('plate')"
                                             class="m-0 mt-sm-0 btn btn-primary"
                                        > Save
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </transition>
                        <!--show the plates stored-->
                        <li v-for="plate in platesList"
                            class="list-group-item container-fluid"
                        >
                            <div class="row d-md-flex justify-content-md-between align-items-center my-5">
                                <div class="col-8  mb-sm-0 text-left">
                                    <div class="plate w-100 w-md-unset"
                                         :class="{
                                        'disabled':(typeof plate.disabled !== 'undefined' && plate.disabled !== null && plate.disabled == true)?true:false
                                    }"
                                    >
                                        {{plate.value}}
                                    </div>
                                </div>
                                <div class="col-4 mt-0 text-right">
                                    <div class="m-0 mt-sm-0 btn btn-flat-primary" v-on:click="deleteAsset(plate.id)">
                                        <i class="material-icons" aria-hidden="true">delete</i>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </template>
            </card-basic>
        </transition>

        <!--        Purchases-->
        <card-basic
                class="mb-2"
        >
            <template slot="title">
                <div class="d-flex justify-content-between align-content-center w-100">
                    <div>
                        <h5 v-if="!view_purchases">View your purchase emails</h5>
                        <p class="text-capitalize" v-else>Click each transaction to view or print your email.</p>
                    </div>
                    <div class="cursor-pointer">
                        <round-button
                                v-if="view_purchases"
                                btn_type="btn-danger"
                                cls="cursor-pointer btn-floating-responsive"
                                :small="false"
                                @clicked="view_purchases = !view_purchases"
                        >
                            <template slot="content">
                                <i class="material-icons">visibility_off</i>
                            </template>
                        </round-button>
                        <round-button
                                v-else
                                btn_type="btn-info"
                                cls="cursor-pointer btn-floating-responsive"
                                :small="false"
                                @clicked="view_purchases = !view_purchases"
                        >
                            <template slot="content">
                                <i class="material-icons">visibility</i>
                            </template>
                        </round-button>

                    </div>
                </div>
            </template>
            <template slot="main">
                <component
                        v-if="view_purchases"
                        is="ul"
                        class="list-group list-group-flush"
                        component="ul">
                    <li class="list-group-item list-group-item-hover"
                        v-for="sale in sales"
                        :key="sale.id">

                        <a class="text-body"
                           target="_blank"
                           :href="ticket_email_uri + sale.id"
                        >
                            <small class="text-uppercase">Your sale order reference: {{sale.reference}}</small>
                            <div class="mb-1 d-flex justify-content-between align-content-center" title="Purchase date">

                                <span class="d-block text-right"
                                      v-if="sale.total_price_paid > 0">Paid on: {{sale.date}}</span>
                                <span v-else>Reserved on: {{sale.date}}</span>
                                <span v-if="sale.total_price_paid > 0"
                                      v-html="formatMoney(sale.total_price_paid)"></span>
                            </div>
                            <div class="d-flex justify-content-between align-content-end"
                                 v-for="sale_content in sale.sale_contents"
                                 :title="(sale_content.status === 'cancelled')?'This item was cancelled':''"
                            >
                                <div data-ref="ticket--details"
                                     class="d-flex justify-content-between align-content-end">

                                    <div>
                                        <small v-if="isSingleTicket(sale_content.ticket_type)">{{getSingleTicketEventName(sale_content)}}</small>
                                        <h6 class="mb-2" :class="{
                                'cancelled-ticket':(sale_content.status === 'cancelled')
                                }"
                                        >
                                            <i class="fa pt-1 pr-1"
                                               :class="[
                                            setTicketIcon(sale_content.ticket_type)
                                            ]"
                                            ></i>
                                            {{sale_content.title}}</h6>
                                    </div>
                                </div>

                                <div data-ref="amount--paid" class="align-self-end mb-2">
                                    <small v-if="sale_content.paid > 0" :class="{
                                'cancelled-ticket':(sale_content.status === 'cancelled')
                                }"
                                           v-html="formatMoney(sale_content.paid)"
                                    ></small>
                                </div>
                            </div>
                        </a>
                    </li>
                </component>
            </template>
        </card-basic>

        <!--account details link-->
        <transition name="fade">
            <card-basic
                    v-show="!view_purchases"
                    data-module-type="account_details"
                    class="mb-2"
                    :display="{
        image_content:'',
        title_content:'Account',
        summary_content:'',
        footer_content:''
        }"
            >
                <template slot="title">
                    Account details
                </template>

                <template slot="main">
                    <a class="btn btn-primary" :href="account_profile_show_route_uri">Profile</a>
                    <a class="btn btn-primary" v-if="is_dev" :href="reset_route">Reset Cache</a>
                    <a class="btn btn-primary active"
                       :class="{
                        'btn-primary':!debug_mode,
                        'btn-secondary':debug_mode,
                       }"
                       v-if="is_dev" :href="performance_switch">Performance Test</a>
                </template>
            </card-basic>
        </transition>
        <!--cards crud-->
        <card-basic
                class="mb-2 "
                v-if="display.cards && cards.length > 0"
                :display="{
        image_content:'',
        title_content:'Cards',
        summary_content:'',
        footer_content:''
        }"
        >
            <template slot="title">

                <span data-toggle="tooltip"
                      title="Your card details are stored by the payment processor. The payment processor is Stripe Payments Europe, Ltd. We do not store your card details within our site/ database e.g card number, expiry date, card holder name etc."
                >
                    <span>Cards saved</span>
                <span v-if="allow_create" v-on:click="createAsset('card')"
                      class="cursor-pointer"
                >
                    <i class="material-icons" aria-hidden="true">add</i>
                </span>
                </span>
            </template>
            <template slot="main">
                <div v-if="allow_create && newAsset.card">
                    <h4>new card crud</h4>
                </div>
                <ul
                        class="list-group"
                        v-for="card in cards"
                >
                    <li class="list-group-item">
                        <div
                                class="d-flex justify-content-between align-items-center"

                        >

                            <card-visa :card="card"></card-visa>
                            <div v-if="isBuyNow(card)"
                                 v-on:click="oneClick(false,card.card_token)"
                                 class="cursor-pointer"
                            >
                                <div class="text-center">1-Click</div>
                                <div class="fs-2 text-center">Active</div>

                            </div>
                            <div v-else
                                 v-on:click="oneClick(true,card.card_token)"
                                 class=" cursor-pointer"
                            >
                                <div class="text-center">1-Click</div>
                                <div class="fs-2 text-center">Set</div>
                            </div>

                            <div class="d-flex align-items-center"
                            >
                                <span>**** **** ****</span> <span class="pl-1">{{card.last4}}</span>
                            </div>

                            <div class="p-2 cursor-pointer"
                                 v-on:click="deleteCard(card.card_token)"
                            >
                                <i class="material-icons" aria-hidden="true">delete</i>
                            </div>
                        </div>
                    </li>
                </ul>
            </template>

        </card-basic>
    </div>
</template>

<script>
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });
    import {_} from 'underscore';
    import {format as money} from '../../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import PlateFormatMixin from "../../../../../../app/Shared/Resources/Assets/js/components/PlateFormatMixin";
    // import {highlight} from '../../effects/est-highlight'

    window.Vue.component('card-basic', require('../../cards/CardBasic.vue'));
    window.Vue.component('card-visa', require('../../cards/CardsVisa.vue'));
    window.Vue.component('floating-button', require('../../../../../../app/Shared/Resources/Assets/js/components/buttons/FloatingButton'));
    export default {
        name: "account-side-bar",
        components: {},
        props: {
            is_dev: {
                type: Boolean,
                default: false
            },
            debug_mode:{
                type:Boolean,
                default:false
            },
            performance_switch: {
                type: String,
                default: null
            },
            reset_route: {
                type: String,
                default: null
            },
            account_sales_records_uri: String,
            ticket_email_uri: String,
            plates_settings: {},
            max_plate_create: 5,
            account_profile_show_route_uri: String,
            assets_route_uri: String,
            asset_delete_route_uri: String,
            assets_store_route_uri: String,
            card_details_update_route_uri: String,
            display: Object,
            allow_create: Boolean,
            is_vip: {
                default: false,
                type: Boolean
            },
            /**
             * @param  {String} sales.sale_contents.status
             * @param  {Object} sales.sale_contents
             * @param {Object} sales
             */
            sales: {
                type: Object,
                default: {}
            },
            col_view_purchases: {
                type: String,
                default: 'col-lg-8 offset-lg-2'
            },
            col_lg: {
                type: String,
                default: 'col-lg-4 col-xl-4'
            },
            order_start: {
                type: String,
                default: 'order-md-0'
            },
            order_end: {
                type: String,
                default: 'order-md-1'
            }
        },
        mixins: [PlateFormatMixin],
        created() {
        },
        destroyed() {
        },
        mounted() {
            let self = this;

            this.sale_route_template = this.ticket_email_uri.slice(0, -1);
            setTimeout(() => {
                self.requestUserAssets();
            }, self.plates.init_delay_time);
        },
        data() {
            return {
                view_purchases: false,
                sale_route_template: '',
                plates: {
                    max_limit: 5,
                    max_notify: false,
                    init_delay_time: 3500
                },
                creating_plate: false,
                needs_plate_asset: false,
                current_buy_now_card_token: '',
                initialised: false,
                newAsset: {
                    plate: false,
                    card: false
                },
                platesList: {},
                newPlate: false,
                plateModel: '',
                plateModelId: _.uniqueId('plate--'),
                user: {
                    user_assets_group: {
                        user_assets: []
                    }
                },
                cards: []
            }
        },
        methods: {
            setTicketIcon(ticket_type) {
                let icon = 'icon-flat-';
                switch (ticket_type) {
                    case 'vip':
                        icon = icon + ticket_type;
                        break;
                    case 'vip-season':
                        icon = icon + 'season-ticket';
                        break;
                    case 'season':
                        icon = icon + 'season-ticket';
                        break;

                    default:
                        icon = icon + 'ticket';

                }
                return icon;
            },
            isSingleTicket(ticket_type) {
                return ticket_type === 'single'
            },
            getSingleTicketEventName(ticket) {
                let keys = Object.keys(ticket.events);
                if (keys.length > 0) {
                    return ticket.events[keys[0]].title;
                }
                return null
            },
            formatMoney(price) {
                return money(price);
            },
            isEmpty(obj) {
                return _.isEmpty(obj);
            },
            highlight(id) {
                let item = document.getElementById(id);
                try {
                    if (!item) {
                        throw new Error(id);
                    }
                } catch (e) {
                    console.error('e', e);
                }
                console.log('this.$refs.new_plate_input', this.$refs, this.$refs['new_plate_input']);
            },
            log(x) {
                console.log('x', x);
            },
            init() {
                this.user = {
                    user_assets_group: {
                        user_assets: []
                    }
                };
                this.cards = [];

                return this;
            },
            sortCards() {
                let self = this;
// console.log('self.user.buy_now',self.user.buy_now);

                let cards = self.user.cards,
                    buy_now = self.user.buy_now;
// console.log('cards',cards);

                for (let index in cards) {
                    /**
                     * @namespace card
                     * @property card.card_token
                     * @property card.last4
                     */
                    let card = cards[index];

                    if (card.card_token === buy_now) {
                        card['buy_now'] = true;
                    }
                    self.cards.push(card);
                }

                // console.log('this.cards', this.cards);
            },
            isBuyNow(card) {
                let isBuyCard = ('buy_now' in card) && card.buy_now === true;
                if (isBuyCard) {
                    this.current_buy_now_card_token = card.card_token;
                }
                // console.log('cisBuyCardard', isBuyCard, card);
                return ('buy_now' in card) && card.buy_now === true;
            },
            /**
             * activate or deactivate one click for this card
             * @param {Boolean} active  true or false to toggle
             * @param {String} token    The token used to identify the card selected
             */
            oneClick(active, token) {

                let data = {
                    use_buy_now: null,
                    cards_to_remove: []
                };

                axios
                    .post(this.card_details_update_route_uri, data)
                    .then(function (response) {
                        if (response.data.success) {
                            this.initialised = false;
                            this.requestUserAssets();
                        }
                    })
                    .catch(function () {

                    });

            },
            deleteCard(token) {
                let data = {
                    use_buy_now: (token !== this.current_buy_now_card_token) ? this.current_buy_now_card_token : null,
                    cards_to_remove: [token]
                };

                axios
                    .post(this.card_details_update_route_uri, data)
                    .then(function (response) {
                        if (response.data.success) {
                            this.requestUserAssets();
                        }
                    })
                    .catch(function () {

                    });
            },
            /**
             *
             * @param {String} type
             */
            createAsset(type) {
                if (!this.is_vip && this.platesLen() >= this.plates.max_limit) {
                    return this.plates.max_notify = true;
                }
                this.newAsset[type] = this.creating_plate = true;
            },
            /**
             *
             * @param {String} type
             */
            cancelAsset(type) {
                this.newAsset[type] = this.creating_plate = false;
            },
            platesLen() {
                let item = _.where(this.user.user_assets_group.user_assets, {type: 'plate'});
                return Object.keys(item).length;
            },

            /**
             * test if the plates are empty then show the notification
             */
            checkPlates() {
                let self = this;

                if (_.isEmpty(self.platesList)) {
                    self.needs_plate_asset = true;
                    return self;
                } else {
                    self.needs_plate_asset = false;
                }
                return self;
            },

            storeAsset(type) {
                let self = this,
                    asset = this.plateModel;

                // console.log('storeAsset', 'asset', asset);
                let data = {
                    type: type,
                    value: asset
                };
                axios
                    .post(this.assets_store_route_uri, data)
                    .then(function (response) {
                        self.plateModel = '';
                        self
                            .requestUserAssets()
                            .then(function (elm) {
                                self.newAsset[type] = false;
                            });

                    })
                    .catch(function () {

                    });

            },
            deleteAsset(id) {
                let self = this;

                let data = {
                    asset_id: id
                };
                this.$set(this.platesList['_' + id], 'disabled', true);

                axios
                    .post(this.asset_delete_route_uri, data)
                    .then(function (response) {
                        if (response.data.success) {
                            self.requestUserAssets();
                        }
                    });

            },
            requestUserAssets() {
                let self = this;

                let data = {};
                // self.init();
                // console.log('requestUserAssets');
                return axios
                    .post(this.assets_route_uri, data)
                    .then(function (response) {
                        if (response.data.success) {
                            self.user = response.data.user;

                            // console.log(response.data.plates);
                            self.platesList = response.data.plates;
                            self.checkPlates();
                        }
                    })
                    .catch(function () {

                    });
            },
        },
        watch: {
            plateModel(newPlate, oldPlate) {
                this.plateModel = this.cleanPlateOnInput(newPlate)
            }
        },
        computed: {}
    }
</script>

<style scoped>
    .cancelled-ticket {
        text-decoration: line-through;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/account/AccountSideBar.vue